const LOADING_ERROR_TEXT = {
  TITLE: 'Eita, algo deu errado por aqui.',
  SUBTITLE: 'Deu erro no sistema bem na hora de carregar a página.',
  RETRY: 'Tente novamente para continuar.',
  BUTTON: 'Tentar novamente'
};

export default LOADING_ERROR_TEXT;
